import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const AlipayPaymentMob = () => {
  return <CommonProcess />;
};

export default AlipayPaymentMob;
